export interface FavoriteChange {
  collectionId: number;
  isFavorite: boolean;
}

const eventName = "cogito:favorite-changed";
const channelName = "cogito-favorites";

export function publishFavoriteChange(change: FavoriteChange) {
  window.dispatchEvent(new CustomEvent<FavoriteChange>(eventName, { detail: change }));
  if ("BroadcastChannel" in window) {
    const channel = new BroadcastChannel(channelName);
    channel.postMessage(change);
    channel.close();
  }
}

export function subscribeFavoriteChanges(listener: (change: FavoriteChange) => void) {
  const onLocal = (event: Event) => listener((event as CustomEvent<FavoriteChange>).detail);
  window.addEventListener(eventName, onLocal);
  const channel = "BroadcastChannel" in window ? new BroadcastChannel(channelName) : null;
  if (channel) channel.onmessage = (event: MessageEvent<FavoriteChange>) => listener(event.data);
  return () => {
    window.removeEventListener(eventName, onLocal);
    channel?.close();
  };
}
